export const QWEN21_MODEL_ID = 'qwen/qwen-image-2.1' as const;
// Noncommercial model evaluation is restricted at both the UI and server.
export const QWEN21_EVALUATOR_ID = '52e58588-a2fe-46ed-b6dd-b22c91a2e27d';
export const canEvaluateQwen21 = (userId?: string) => userId === QWEN21_EVALUATOR_ID;

export const QWEN21_DIMENSIONS: Record<string, readonly [number, number]> = {
    '1:1': [1024, 1024], '2:3': [1024, 1536], '3:2': [1536, 1024],
    '9:16': [864, 1536], '16:9': [1536, 864], '4:3': [1152, 864],
    '3:4': [864, 1152], '4:5': [1024, 1280], '5:4': [1280, 1024],
    '21:9': [1568, 672], '9:21': [672, 1568],
};
